// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8e-4";
export var collapsed = "_8e-1";
export var headerBar = "_8e-0";
export var leftHeaderContent = "_8e-3";
export var subjectContainer = "_8e-2";